var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"dc056ae9aa61d8ca8f09acb0cf36aec878bc260f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["prism@bay-area-news-group-p0"]={id:"dc056ae9aa61d8ca8f09acb0cf36aec878bc260f"};
      